<template>
    <section-wrapper
        class="appointment"
        :this-section="Section.APPOINTMENT"
        :section-end-button-in-dom="false">
        <iframe
            class="appointment__iframe"
            :src="settings.onlineAppointmentSchedulerUrl"
            :title="$t('investmentProposal.closeWith.appointment.linkLabel')" />
    </section-wrapper>
</template>

<script>
import { Section } from '@/enums';
import SectionWrapper from '@/components/common/SectionWrapper';
import { mapGetters } from 'vuex';

export default {
    name: 'Appointment',
    components: {
        SectionWrapper,
    },
    data () {
        return {
            Section,
        };
    },
    computed: {
        ...mapGetters(['settings']),
    },
};
</script>

<style scoped lang="scss">
.appointment__iframe {
  border: none;
  width: 100%;
  height: 1175px;
}
</style>
